<template>
  <v-container fluid>
    <v-col>
      <v-row justify="center" align="center" style="height: 90vh">🦋</v-row>
    </v-col>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.color,
        },
      ],
    };
  },
  mounted() {
    this.$router.push(`/guest/TZpsRh6twpvS4ovycbTp`);
  },
  computed: {
    ...mapState(["user"]),
    color() {
      if (this.lightMode) {
        return "#62A0F0";
      } else {
        return "#021F23";
      }
    },
    lightMode: {
      get() {
        return this.$store.state.lightMode;
      },
      set(val) {
        return this.$store.commit("setLightMode", val);
      },
    },
  },
};
</script>

<style>
</style>
